export default __webpack_public_path__ + "media/images/header-logo-96e7fd58f38e2b3b8625e740d468926c.png";